export default {
  common: {
    loading: "Loading",
    error: "Error",
    noData: "No data available",
    back: "Back",
  },
  nav: {
    historicalStats: "Historical Statistics",
    liveView: "Live View",
    settings: "Settings",
    logout: "Logout",
  },
  auth: {
    login: "Login",
    username: "Username",
    password: "Password",
    usernamePlaceholder: "Enter your username",
    passwordPlaceholder: "Enter your password",
    usernameRequired: "Username is required",
    passwordRequired: "Password is required",
    unexpectedError: "An unexpected error occurred",
  },
  projects: {
    title: "Projects",
    loading: "Loading your projects...",
    failedToLoad: "Failed to load projects",
    noProjectsYet: "No projects yet",
    noProjectsDesc: "You have not been assigned to any projects",
    viewProject: "View project",
    role: {
      admin: "Admin",
      member: "Member",
    },
    eventCount: "no events | 1 event | {count} events",
  },
  events: {
    title: "Events",
    backToProjects: "Back to projects",
    failedToLoad: "Failed to load events",
    noEventsYet: "No events yet",
    noEventsDesc: "This project has no events",
    viewEvent: "View event",
    created: "Created on {date}",
    status: {
      upcoming: "Upcoming",
      live: "Live",
      ended: "Ended",
    },
  },
  filters: {
    cameras: "Cameras",
    date: "Date",
    dateRange: "Date range",
    class: "Class",
    granularity: "Granularity",
    allCameras: "All cameras",
    selectDate: "Select date",
    selectDateRange: "Select date range",
    selectClass: "Select class",
    selectGranularity: "Select granularity",
    camsSelected: "no cameras selected | 1 camera selected | {count} cameras selected",
    sectors: "Sectors",
    allSectors: "All sectors",
    sectorsSelected: "no sectors selected | 1 sector selected | {count} sectors selected",
    granularityOptions: {
      minute: "Minute",
      hour: "Hour",
      day: "Day",
    },
    classNames: {
      person: "Person",
      car: "Car",
      truck: "Truck",
      bus: "Bus",
      bicycle: "Bicycle",
      motorcycle: "Motorcycle",
      boat: "Boat",
      all: "All Classes",
    },
    zone: "Zone",
    allZones: "All zones",
    detail: "Detail",
    allDetails: "All details",
    groupBy: "Group by",
    groupByOptions: {
      camera: "Camera",
      zone: "Zone",
      detail: "Detail",
    },
  },
  stats: {
    title: "Historical Statistics",
    loading: "Loading",
    loadingDesc: "Loading data from API...",
    failedToLoad: "Failed to load data",
    failedToLoadDesc: "Failed to fetch detection data",
    noDataAvailable: "No data available",
    noDataDesc: "No detection data found for selected filters",
    initializing: "Initializing dashboard...",
    detectionsPerSector: "Detections per sector",
    warnThreshold: "Warning",
    alertThreshold: "Alert",
    perMinute: "per minute",
    densityUnit: "per m²",
    directionUnit: "crossings",
  },
  schedules: {
    title: "Event Camera Schedules",
    loading: "Loading schedules...",
    failedToLoad: "Failed to load schedules",
    noSchedules: "No schedules assigned to this event",
    table: {
      scheduleName: "Schedule name",
      camera: "Camera",
      startTime: "Start time",
      endTime: "End time",
      duration: "Duration",
      status: "Status",
    },
  },
  live: {
    title: "Live View",
    eventNotFound: "Event not found",
    eventNotFoundDesc: "The requested event could not be found",
    eventLive: "Event is currently live",
    eventEnded: "Event has ended",
    eventEndedDesc: "This event ended on {date}",
    noCameras: "No cameras assigned to this event",
    waitingForData: "Waiting for camera data...",
    loading: "Loading live statistics...",
    sector: "Sector",
    dayOfEvent: "Day {current} of {total}",
    badges: {
      live: "Live",
      recent: "Recent",
    },
    updatedAgo: "Updated {seconds}s ago",
    camsAllOnline: "all online",
    camsAllOffline: "all offline",
    camsSomeOffline: "{count} offline",
    camsNone: "no cams",
    activeMap: "Active map",
    camCount: "no cams | 1 cam | {count} cams",
    online: "online",
    offline: "offline",
    staleTag: "stale",
    lastUpdate: "Last update {time}",
    densityValue: {
      alert: "ALERT",
      warning: "WARN",
      ok: "OK",
    },
    sectorStatus: {
      noData: "NO DATA",
      incomplete: "INCOMPLETE",
      stale: "STALE",
      partlyStale: "PARTLY STALE",
      alert: "ALERT",
      warning: "WARN",
      normal: "OK",
    },
    zoneTable: {
      zone: "Zone",
      cam: "Cam",
      class: "Class",
      count: "N",
      area: "m²",
      density: "D",
      noData: "no data",
      updated: "Updated",
    },
    statusText: {
      alert: "alert",
      warning: "warn",
      normal: "ok",
    },
    configTable: {
      zone: "Zone",
      cam: "Cam",
      class: "Class",
      area: "Area",
      minAngle: "Min∠",
      maxAngle: "Max∠",
      warn: "Warn ≥",
      alert: "Alert ≥",
    },
    camTable: {
      camera: "Camera",
      status: "Status",
      lastSeen: "Last seen",
      startEnd: "Start / End",
    },
    alertStrip: {
      alert: "{n} sector in alert: | {n} sectors in alert: ",
      warning: "{n} sector with warning: | {n} sectors with warning: ",
      bothSuffix: "(+ {n} with warnings)",
    },
  },
  countdown: {
    title: "Event starts in",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
  },
  charts: {
    detections: "Detections by {granularity} - {subtitle}",
    cumulativeDetections: "Cumulative detections by {granularity} - {subtitle}",
    detectionsPerCamera: "Detections per camera",
    detectionsPerTimeslot: "Detections per {granularity}",
    detectionsLabel: "detections",
    granularity: {
      minute: "Minute",
      hour: "Hour",
      day: "Day",
      week: "Week",
      month: "Month",
      year: "Year",
    },
    monthLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    timeLabels: {
      midnight: "12a",
      noon: "12p",
      amSuffix: "a",
      pmSuffix: "p",
    },
  },
}
